/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function t(t,o,n,i={},f={}){return"function"==typeof o&&(o=o(void 0!==n?n:t.custom,i,f)),"string"==typeof o&&(o=t.variants&&t.variants[o]),"function"==typeof o&&(o=o(void 0!==n?n:t.custom,i,f)),o}export{t as resolveVariantFromProps};
//# sourceMappingURL=resolve-variants.js.map
